import React from 'react';
import { NumericFormat } from 'react-number-format';
import { Col, Container, Modal, ModalBody, Row, Label, Input, Form, FormGroup } from 'reactstrap';
import modalclose from '../../../images/close.png';
import FYearService from '../../../services/FYearService';
import { CommonButton } from '../../CommonComponents';
import CustomSpinner from '../../CustomSpinner/CustomSpinner';
import './index.css';

const CompanyModal = ({ isModalLoading, isOpen, toggle, editCompanyId, handleSubmitCompany, companyName, setCompanyName, companyYear, companyTurnOver, setCompanyTurnOver}) => {
    let fYYear = FYearService.getFYear();
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered className="CompanyModal" id='CompanyModal'>
            {isModalLoading && <CustomSpinner />}
            <ModalBody className='pb-0'>
                <div className="closeButton d-flex justify-content-end mb-3">
                    <img src={modalclose} alt="close" onClick={toggle} className="cursorPointer" />
                </div>
                <div className='modalHeading flex-column'>
                    <div className='title text-capitalize'>Company Wise Last Year Turnover</div>
                </div>
                <div className='bodyArea'>
                    <Container fluid>
                        <Form onSubmit={handleSubmitCompany}>
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label className='common-input-label'>
                                            {'Enter Company Name'}&nbsp;
                                            <span className='required'>*</span>
                                        </Label>
                                        <br />
                                        <Input
                                            type='text'
                                            autoComplete='off'
                                            required
                                            value={
                                                companyName === null || companyName === 'undefined'
                                                    ? ''
                                                    : companyName
                                            }
                                            onChange={(e) => setCompanyName(e.target.value)}
                                            name='name'
                                            id='name'
                                            placeholder='Type here'
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label className='common-input-label'>
                                            Financial Year&nbsp;
                                            <span className='required'>*</span>
                                        </Label>
                                        <br />
                                        <div className='select-wrapper'>
                                            <Input
                                                type='text'
                                                name='detail'
                                                id='select'
                                                disabled
                                                value={editCompanyId ? companyYear : fYYear.prevFinancialYear}
                                                placeholder='Type here'
                                            />
                                        </div>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label className='common-input-label'>
                                            Enter Turnover&nbsp;
                                            <span className='required'>*</span>
                                        </Label>
                                        <br />
                                        <NumericFormat
                                            type='text'
                                            autoComplete='off'
                                            name='detail'
                                            required
                                            thousandSeparator={true}
                                            thousandsGroupStyle='lakh'
                                            className='format-number w-100'
                                            onKeyPress={(event) => {
                                                if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                }
                                            }}
                                            value={
                                                companyTurnOver === null || companyTurnOver === 'undefined'
                                                    ? ''
                                                    : companyTurnOver
                                            }
                                            onChange={(e) => setCompanyTurnOver(e.target.value)}
                                            id='detail'
                                            placeholder='Type here'
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className='modalBtn d-flex align-items-center justify-content-center'>
                                        <CommonButton name={editCompanyId ? 'Update' : 'Add'} btnClass={'btnPrimary'} type="submit" />
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </Container>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default CompanyModal
